import { SQLService } from '../../../services/sql.service';
import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-scan-moderator',
  templateUrl: './scan-moderator.component.html',
  styleUrls: ['./scan-moderator.component.styl']
})
export class ScanModeratorComponent implements OnInit {
  constructor(
    public sql: SQLService,
    private navCtrl: ModalController,
    private router: Router) {
  }
  list:string;
  end(e) {
    if (this.navCtrl) this.navCtrl.dismiss(e);
  }
  ngOnInit() {
  }
}